import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchDailyVehiclesSalesAndStockSummary = (filters) => {
  const clientId = filters.clientId ? `&clientId=${filters.clientId}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';
  const salesType = filters.salesType ? `&salesType=${filters.salesType}` : '';

  const allFilters = `${clientId}${startDate}${endDate}${salesType}`;

  return apiActionCreator({
    'endpoint': `/vehicles/daily-vehicle-sales-summary?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DAILY_VEHICLES_SALES_SUMMARY,
      ActionTypes.FETCHED_DAILY_VEHICLES_SALES_SUMMARY,
      [
        ActionTypes.FETCHED_DAILY_VEHICLES_SALES_SUMMARY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadDailyVehiclesSalesAndStockSummary = (filters) => {
  const clientId = filters.clientId ? `&clientId=${filters.clientId}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';
  const salesType = filters.salesType ? `&salesType=${filters.salesType}` : '';
  const allFilters = `${clientId}${startDate}${endDate}${salesType}`;

  return apiActionCreator({
    'endpoint': `/vehicles/daily-vehicle-sales-summary/excel?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_DAILY_VEHICLES_SALES_SUMMARY,
      ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY,
      [
        ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
